import React, { useMemo, useCallback, useEffect, useState } from 'react';
import { Box, FormControl, FormHelperText } from '@material-ui/core';
import { useSelector, useLocation } from 'umi';
import { useDispatch } from 'dva';
import { Controller } from 'react-hook-form';
import { TextFieldCom, UploadImageCom } from './FormType';
import DialogMl from './Dialog';
import { OPT_DETAIL } from '@/constants';
import DateRangePickerML from '@/components/DateRangePickerML';
import FocusedCoupon from './FocusedCoupon/FocusedCoupon';

export default ({ control, setValue, getValues, errors }) => {
  const { couponList, defaultValues } = useSelector(
    (state) => state.voucherEdit,
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, opt } = query;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState();
  //当前视口宽度
  const clientWidth = document.body.clientWidth;
  //当前视口高度
  const clientHeight = document.body.clientHeight;
  useEffect(() => {
    setValue('coupons', couponList);
  }, [couponList, setValue]);

  const handlePreviewClose = () => {
    setPreviewUrl();
    setPreviewOpen(false);
  };
  //点击图片预览
  const handlePreview = (imgUrl) => {
    setPreviewUrl(imgUrl);
    setPreviewOpen(true);
  };
  //appid 从后端接口获取
  const fetchAppIdList = useCallback(() => {
    dispatch({
      type: 'addTemplate/getAppIdList',
      payload: {
        values: {
          accountType: 'MINIPROGRAM',
        },
      },
      callback: () => {},
    });
  }, [dispatch]);
  useEffect(() => {
    fetchAppIdList();
  }, [fetchAppIdList]);

  useMemo(() => {
    if (defaultValues && id) {
      for (let v in defaultValues) {
        setValue(v, defaultValues[v]);
      }
    }
  }, [defaultValues, setValue, id]);

  return (
    <Box display="flex" flexDirection="column">
      <Box
        sx={{
          color: '#212121',
          fontSize: '18px',
          fontWeight: '600',
          marginBottom: '32px',
        }}
      >
        基本设置
      </Box>
      <Box className="display-column-between" gap="32px 0">
        <Box width="320px">
          <TextFieldCom
            label="活动名称"
            showError={true}
            control={control}
            name="name"
            setValue={setValue}
            getValues={getValues}
            disabled={opt === OPT_DETAIL}
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
              maxLength: 15,
            }}
            errors={errors}
          />
        </Box>
        <Box>
          <FormControl variant="standard">
            <Controller
              render={(rp) => (
                <DateRangePickerML
                  label="开始时间"
                  title="结束时间"
                  minDate={(!id && new Date()) || null}
                  startText={
                    <>
                      <span style={{ color: 'red' }}>*</span>
                      开始时间
                    </>
                  }
                  endText={
                    <>
                      <span style={{ color: 'red' }}>*</span>
                      结束时间
                    </>
                  }
                  defaultStartDate={defaultValues?.date?.startDate}
                  defaultEndDate={defaultValues?.date?.endDate}
                  rp={rp}
                  setValue={setValue}
                  name="custom-form-submit-name"
                  disabled={opt === OPT_DETAIL}
                />
              )}
              name="date"
              control={control}
              rules={{
                validate: () =>
                  !(
                    !getValues('date') ||
                    !getValues('date').startDate ||
                    !getValues('date').endDate
                  ),
              }}
            />
            <FormHelperText error={Boolean(errors.date)}>
              {errors.date && '日期不得为空'}
            </FormHelperText>
          </FormControl>
        </Box>

        <Box>
          <Controller
            render={(pr) => (
              <UploadImageCom
                uW="150"
                uH="150"
                iW="150"
                iH="150"
                pr={pr}
                label={
                  <>
                    <span style={{ fontSize: '16px' }}>落地页底图</span>
                    <span style={{ marginLeft: '6px', color: '#999999' }}>
                      建议尺寸750px * 1600px，最多上传1张
                    </span>
                  </>
                }
                showSuccessNumber={true}
                required={true}
                disabled={opt === OPT_DETAIL}
                getValues={getValues}
                maxNumber="1"
                handlePreview={handlePreview}
                defaultValues={defaultValues?.backgroundImg}
              />
            )}
            name="backgroundImg"
            control={control}
            rules={{
              required: true,
            }}
          />
          <FormHelperText error={Boolean(errors.backgroundImg)}>
            {errors.backgroundImg && '请选择落地页底图'}
          </FormHelperText>
        </Box>
        <Box>
          <TextFieldCom
            style={{ width: '848px' }}
            autoFocus={false} //If true, the input element is focused during the first mount.
            initLabel={false} //自定义的label是否显示
            showLabel={true} //是否需要显示label
            helperText="" //用于校验的提醒文字
            disabled={opt === OPT_DETAIL}
            name="description"
            label="活动规则" //label
            control={control}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            isNumber={false}
            isPositiveNumber={true} //true 只能输入正数，false可以输入负数
            isParseInt={true} //true 只能输入正整数，false可以输入小数
            showError={true} //false输入框捕获到错误不展示错误样式，默认true
            multiline={true} //开启多行
            maxRows="4"
            minRows="4"
            variant="outlined"
            textClassName="textField-area-wrap"
            rules={{
              maxLength: 500,
            }}
          />
        </Box>
      </Box>

      <Box>
        <Box
          sx={{
            color: '#212121',
            fontSize: '18px',
            fontWeight: '600',
            marginBottom: '32px',
            marginTop: '56px',
          }}
        >
          优惠券设置
        </Box>
        <Controller
          control={control}
          name="coupons"
          disabled={opt === OPT_DETAIL}
          as={<FocusedCoupon />}
        />
      </Box>
      <DialogMl onClose={handlePreviewClose} visible={previewOpen}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            alt=""
            src={previewUrl}
            style={{
              maxWidth: `${clientWidth * 0.6}px`,
              maxHeight: `${clientHeight * 0.6}px`,
              margin: 'auto',
            }}
          />
        </div>
      </DialogMl>
    </Box>
  );
};
